<ion-content>
  <ion-grid>
    <ion-row>
      <div class="cards-wrapper">
        @for (a of sortedAnnouncements; track trackByFn(i, a); let i = $index) {
          <ion-col size="12" sizeSm="6">
            <ion-card
              data-cy="msgAnnouncementCard"
              [ngClass]="{ unread: !a.isRead, archived: !a.publishedAt }"
              (click)="openMessage(a)"
            >
              <ion-card-header class="card-header">
                <header>
                  <ion-card-title>
                    @if (!a.publishedAt) {
                      <ion-text color="danger">[ARCHIV]</ion-text>
                    }
                    {{ a.title }}
                    @if (a.attachmentUri) {
                      <ion-icon name="attach-outline"></ion-icon>
                    }
                  </ion-card-title>
                  <ion-card-subtitle>
                    <span class="publishedBy">{{ a.publishedByUser.fullName() }}</span>
                    <span class="publishedAt">{{ a.publishedAt | date: 'd. M. y, H:mm' }}</span>
                  </ion-card-subtitle>
                </header>
                <ion-row class="buttonRow">
                  <ion-button
                    data-cy="msgAnnouncementMenuBtn"
                    (click)="$event.stopPropagation(); openPopover($event, a)"
                    fill="clear"
                    color="tertiary"
                  >
                    <ion-icon name="ellipsis-vertical"></ion-icon>
                  </ion-button>
                </ion-row>
              </ion-card-header>
              <ion-card-content id="body">
                <ng-template [nestedEllipsis]><div [innerHTML]="a.content | bypassHtmlSanitizer"></div></ng-template>
              </ion-card-content>
            </ion-card>
          </ion-col>
        }
      </div>
    </ion-row>
  </ion-grid>
</ion-content>
